export function bannerSmokeEffect() {
  const banner = document.querySelector("#home-video-banner") as HTMLElement;
  if(!banner) return;
  const videoContainer = banner.querySelector('.home-banner-video-container') as HTMLElement;
  videoContainer.classList.add("is-play");
}

export function videoMuteBtn() {
  const videoTag = document.querySelector(".home-banner-video") as HTMLVideoElement;
  if (!videoTag) return;

  const muteBtn = document.querySelector('.muteBtn') as HTMLElement;

  muteBtn.addEventListener("click", () => {
    videoTag.muted = !videoTag.muted;
  })
}